<template>
  <storeMain>
    <div class="shopping-container">
      <!--tab栏切换-->
      <Tabs class="store_content_box" :animated="false" v-model="navTabs">
        <TabPane :label="$t('key1000033')" name="allProducts">
          <shopList shopType="store" :supplierMerchantId="supplierInfo.ymsMerchantId"></shopList>
        </TabPane>
        <TabPane :label="$t('key1006775')" name="companyFiles">
          <div class="company_box">
            <h3 class="title">{{ supplierInfo.name }}</h3>
            <div class="company_line">
              <span>{{ $t('key1006776') }}</span>
              <span>{{ supplierInfo.address }}</span>
            </div>
            <div class="company_line">
              <span>{{ $t('key1002766') }}</span>
              <img class="business_license" :src="setImgPath(supplierInfo.businessLicensePath)" alt="">
            </div>
          </div>
        </TabPane>
      </Tabs>
    </div>
  </storeMain>
</template>

<script>
import shopList from "@/views/shopping/common/shopList";
import storeMain from "@/components/layout/shopping/storeMain";
import Mixin from "@/components/mixin/common_mixin";

export default {
  mixins: [Mixin],
  data() {
    return {
      breadcrumbList: [],
      navTabs: 'allProducts',
      businessLicenseImg: './static/images/placeholder.jpg',
      ymsProductCategoryIdList: []
    };
  },
  computed: {
    // 供应商的基本信息
    supplierInfo() {
      let supplierInfo = this.$store.state.supplierInfo;
      if (supplierInfo) {
        return supplierInfo;
      } else {
        return '';
      }
    }
  },
  components: {
    storeMain,
    shopList
  }
};
</script>

<style lang="less" scoped>

.shopping-container {
  .ivu-tabs /deep/ .ivu-tabs-nav {
    font-size: 15px;
  }

  .store_content_box {
    width: 1200px;
    margin: 0 auto;
  }

  .ivu-tabs-content {
    .company_box {
      color: #333;

      .title {
        font-size: 17px;
        font-weight: bolder;
      }

      .company_line {
        margin-top: 15px;
        font-size: 15px;
        display: flex;

        .business_license {
          display: inline-block;
          width: 250px;
          height: auto;
        }
      }
    }
  }
}
</style>
